import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import { useState } from "react";
import { MdOutlineArrowDropDownCircle } from "react-icons/md";

export default function EmployeePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const empId = location?.state?.empId;

  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Button route config
  const tabs = [
    { label: "Employee List", path: `/employee` },
    { label: empId ? "Edit Employee" : "Add Employee", path: `/employee/new-emp` },
    { label: "Employee To Do List", path: `/employee/todo-list` },
  ];

  return (
    <section className="p-4">
      {/* Desktop Tabs */}
      <div className="hidden sm:flex gap-3 items-center py-3 border-b border-gray-400">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          return (
            <Button
              key={tab.path}
              variant="outlined"
              onClick={() => navigate(tab.path)}
              className={`
                !capitalize !text-[15px] !font-medium
                ${isActive
                  ? "!bg-zinc-700 !text-white !border-none"
                  : "!bg-gray-200 !text-primary !border-zinc-400"
                }
              `}
            >
              {tab.label}
            </Button>
          );
        })}
      </div>

      {/* Mobile Dropdown */}
      <div className="sm:hidden relative border-b border-gray-400 mb-2">
        <button
          onClick={() => setDropdownOpen(!dropdownOpen)}
          className="flex justify-between items-center w-full bg-gray-200 px-4 py-2 rounded text-left"
        >
          <span>
            {tabs.find((t) => t.path === location.pathname)?.label || "Select Tab"}
          </span>
          <MdOutlineArrowDropDownCircle className="text-2xl" />
        </button>
        {dropdownOpen && (
          <ul className="absolute z-10 w-full bg-white border mt-1 rounded shadow-lg max-h-60 overflow-y-auto">
            {tabs.map((tab) => {
              const isActive = location.pathname === tab.path;
              return (
                <li
                  key={tab.path}
                  className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${isActive ? "bg-gray-200 font-medium" : ""}`}
                  onClick={() => {
                    navigate(tab.path);
                    setDropdownOpen(false);
                  }}
                >
                  {tab.label}
                </li>
              );
            })}
          </ul>
        )}
      </div>

      <div className="mt-4 bg-white p-4 shadow-md rounded-[4px]">
        <Outlet />
      </div>
    </section>
  );
}
